module.exports = __webpack_public_path__ + "static/media/favicon.8fa00104.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Messenger/favicon.png
// module id = 1113
// module chunks = 0